import {fromJS, Map} from 'immutable';
import settingsActions from '../actions/settings.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {PayoutAccount} from '../../shared/types/payout/PayoutPublic';

export interface SettingsState {
    loading: boolean;
    payoutAccount: PayoutAccount;
    loadingPayout: boolean;
    updateFailed: boolean;
    completedPayoutAndTax: boolean;
}

export const DEFAULT_STATE = fromJS({
    payoutAccount: {},
    loading: false,
    loadingPayout: false,
    updateFailed: false,
    completedPayoutAndTax: false
});

export const settingsReducer = (state: Map<keyof SettingsState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case settingsActions.TYPES.GET_PAYOUT: {
            newState = newState.updateIn(['loadingPayout'], () => true);
            return newState;
        }

        case settingsActions.TYPES.GET_PAYOUT_COMPLETE: {
            const {payoutAccount} = action.payload;
            const currentState = state.toJS();
            newState = fromJS({
                ...currentState,
                payoutAccount: payoutAccount.data && payoutAccount.data[0],
                loadingPayout: false,
                completedPayoutAndTax:
                    payoutAccount.data && Object.keys(payoutAccount.data).length !== 0
            });
            return newState;
        }

        case settingsActions.TYPES.UPDATE_SETTINGS: {
            const currentState = state.toJS();
            const payoutAccount = {...currentState, ...action.payload.payout};
            newState = newState.updateIn(['loadingPayout'], () => true);
            newState = newState.updateIn(['payoutAccount'], () => payoutAccount);
            return newState;
        }

        case settingsActions.TYPES.UPDATE_SETTINGS_COMPLETE: {
            const _payoutAccount = action.payload;
            const slugOptions = state.toJS().slugOptions;
            newState = fromJS({
                slugOptions,
                payoutAccount: _payoutAccount
                    ? _payoutAccount.data
                    : state.get('payoutAccount').toJS(),
                loadingPayout: false
            });
            return newState;
        }
        case settingsActions.TYPES.UPDATE_SETTINGS_FAILED: {
            newState = newState.updateIn(['updateFailed'], () => true);
            newState = newState.updateIn(['loadingPayout'], () => false);
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('settings', settingsReducer);
